import classes from "./styles.module.css"
import {Button} from "@mui/material";
import {useState} from "react";

const Row_org_user =(props)=>{

    const [data, setData] = useState(props.data);
console.log(props);

    const deleteFn = () => {
        if (props.onDeleteRequest) {
            props.onDeleteRequest(props.data);
        } else if (props.delete) {
            props.delete(props.data.id);
        }
    };

    const editFn = () => {
        if (props.onEdit) {
            props.onEdit(data);
        }
    }

    const act = (
        <>
            <Button onClick={editFn} color="primary" variant="outlined" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '4px 8px', sm: '6px 16px' }, minWidth: { xs: 'auto', sm: '100px' }, width: { xs: '100%', sm: 'auto' } }}>Upravit</Button>
            <Button onClick={()=>deleteFn()} color="primary" variant="outlined" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '4px 8px', sm: '6px 16px' }, minWidth: { xs: 'auto', sm: '100px' }, width: { xs: '100%', sm: 'auto' } }}>Odstranit</Button>
        </>
    );

    if (props.renderAsGridRow) {
        return (
            <div style={{ display: 'contents' }}>
                <div className={`${classes.cellData} ${classes.cellColFirst} ${props.isLastRow ? classes.cellRowLast : ''} ${classes.column}`}><span className={classes.mobileLabel}>Uživatel:</span>{data.username}</div>
                <div className={`${classes.cellData} ${props.isLastRow ? classes.cellRowLast : ''} ${classes.column}`}><span className={classes.mobileLabel}>Organizace:</span>{data.name}</div>
                <div className={`${classes.cellData} ${classes.cellColLast} ${props.isLastRow ? classes.cellRowLast : ''} ${classes.columnAct}`}>{act}</div>
            </div>
        );
    }

    const gridStyle = props.gridColumns ? { gridTemplateColumns: props.gridColumns } : undefined;
    return  <div className={classes.columns} style={gridStyle}>
        <div className={classes.column}>
            <span className={classes.mobileLabel}>Uživatel:</span>
            {data.username}
        </div>
        <div className={classes.column}>
            <span className={classes.mobileLabel}>Organizace:</span>
            {data.name}
        </div>
        <div className={classes.columnAct}>{act}</div>
    </div>
}
export default Row_org_user;